// /CustomButton/CustomButton.js
import React from 'react'
import { ShoppingCartOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react-lite'
import WrapperLoginRequired from '../../Power/WrapperLoginRequired'
import { GeneralButton } from '../GeneralComponents'

// Optional templates to avoid rewriting all usages.
const BUTTON_TEMPLATES = {
	demo: { type: 'primary', style: { borderRadius: 0 } },
	primary: { type: 'primary' },
	'icon-cart': {
		type: 'primary',
		shape: 'circle',
		icon: <ShoppingCartOutlined />
	}
}

const CustomButton = ({
	loginRequired,
	wrapper,
	template,
	children,
	...props
}) => {
	const usedProps = { ...(BUTTON_TEMPLATES[template] || {}), ...props }
	let button = <GeneralButton {...usedProps}>{children}</GeneralButton>
	button = wrapper ? wrapper(button) : button

	const ButtonWrapper = ({ children }) => {
		if (!Boolean(loginRequired)) return <>{children}</>

		return (
			<WrapperLoginRequired {...loginRequired}>
				{children}
			</WrapperLoginRequired>
		)
	}
	ButtonWrapper.propTypes = {
		children: PropTypes.node.isRequired
	}

	return <ButtonWrapper>{button}</ButtonWrapper>
}

CustomButton.propTypes = {
	loginRequired: PropTypes.object,
	wrapper: PropTypes.func,
	template: PropTypes.oneOf(Object.keys(BUTTON_TEMPLATES)),
	children: PropTypes.node
}

export default observer(CustomButton)
